import React from 'react';
import { NavLink } from 'react-router-dom';

const MenuItems = [
  { path: 'dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt' },
  { path: 'nanny', label: 'Nannies', icon: 'fas fa-female' },
  { path: 'family', label: 'Family Nanny Requests', icon: 'fas fa-user-friends' },
  // { path: 'requests/nanny', label: 'Nanny Requests', icon: 'fas fa-female' },
  { path: 'requests/sitter', label: 'Sitter Requests', icon: 'fas fa-female' },
  { path: 'contact-us/list', label: 'Contact Form', icon: 'fa fa-envelope' },
  { path: 'subscribers/list', label: 'Mailing List', icon: 'fas fa-newspaper' },
  // { path: 'postings', label: 'Job Postings', icon: 'fas fa-user-tie' },
  { path: 'skills', label: 'Skills', icon: 'far fa-id-badge' },
  { path: 'postings', label: 'Job Listings', icon: 'far fa-id-badge' },
  { path: 'settings', label: 'Settings', icon: 'fas fa-cog' },
];

const Sidebar = () => {
  return (
    <div id="sidebar" className="sidebar py-3">
      <ul className="sidebar-menu list-unstyled">
        {MenuItems.map((x, idx) => {
          return (
            <li key={idx} className="sidebar-list-item">
              <NavLink
                to={`/admin/${x.path}`}
                className="sidebar-link text-muted"
                onClick={() => {
                  document.body.classList.remove('menu-open');
                }}
              >
                <i className={`${x.icon} mr-3 text-gray`} />
                <span>{x.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Sidebar;
